<h1 mat-dialog-title
  class="draggable-dialogue-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle>
  {{title}}
</h1>
<div mat-dialog-content>
  <div>
    <mat-form-field appearance="outline" class="input">
      <mat-label>Role Name</mat-label>
      <input matInput [(ngModel)]="role.name" placeholder="{{role.name}}" name="roleName" autocomplete="off" required />
    </mat-form-field>
  </div>
  <div>
    <div class="div-float-left">
      <mat-checkbox [(ngModel)]="role.isSiteLevel" name="isSiteLevel" [disabled]="role.isSiteAdmin" (click)="validateSiteTreeVisibility()">Site-Level Role</mat-checkbox>
    </div>
    <div cvlass="div-float-left">
      <mat-checkbox [(ngModel)]="role.isSiteTreeViewable" name="isSiteTreeViewViewable" [disabled]="!role.isSiteLevel">Display Site Tree</mat-checkbox>
    </div>
  </div>
  <br /><br />
  <div>
    @if (GetShowWarning()) {
      <span class="warning">Making this folder-level role site-wide will remove all members from this role at the folder level and add them at the site level.</span>
    }
  </div>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" class="theme-primary-btn" [mat-dialog-close]="this.role" [disabled]="DisableSave()">Save</button>
  @if (ShowCancel()) {
    <button mat-flat-button type="button" [mat-dialog-close]="null">Cancel</button>
  }
  @if (!ShowCancel()) {
    <button mat-flat-button type="button" (click)="reset()">Reset</button>
  }
</div>
